<template>
  <div class="main-card mb-3 card">
    <div class="card-header">
      Modules
      <div class="btn-actions-pane-right">
        <button type="submit" class="btn btn-primary" @click.stop.prevent="handleClickSave">Save</button>
      </div>
    </div>
    <div class="card-body">
      <ul class="list-module select-list">
        <li v-for="(object, index) in data" :key="index" class="checkbox-container">
          <input type="checkbox" name="options[module]" :value="index" :checked="values.indexOf(index) !== -1" @click="changeModule" /><span class="checkmark user">{{ object.label }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Event from '@/helper/event.js'
export default {
  mixins: [Event],
  computed: {
    storeId() {
      return 'main'
    },
    data() {
      return this.store.getter('data.module', {})
    },
    values() {
      return Object.values(this.store.getter('values.module', []))
    }
  },
  methods: {
    changeModule(e) {
      let values = Object.values(this.values)
      if (e.target.checked == true) {
        values.push(e.target.value)
      } else if (values.indexOf(e.target.value) !== -1) {
        values.splice(values.indexOf(e.target.value), 1)
      }
      this.store.commit('values.module', values)
    },
    handleClickSave() {
      this.$emit('submitSetting')
    }
  }
}
</script>

<style lang="scss">
body.page-general-option {
  .list-module {
    padding: 0;
    margin: 0 -5px;
    .checkbox-container {
      display: inline-block;
      margin: 5px;
      background: #eee;
      .checkmark {
        padding: 3px 10px;
        margin-right: 0;
      }
      input {
        &:checked ~ .checkmark {
          color: #fff;
          background-color: #2196f3;
        }
      }
    }
  }
}
</style>
